import React, { createContext, useContext } from 'react'
import { compose, withState, lifecycle } from 'recompose'
import isNode from 'detect-node'
import config from 'config'

export const GoogleMapsContext = createContext(false)

const GoogleMapsProviderView = ({ isReady, children }) => {
  return (
    <GoogleMapsContext.Provider value={isReady}>
      {children}
    </GoogleMapsContext.Provider>
  )
}

export const GoogleMapsProvider = compose(
  withState('isReady', 'setIsReady', false),

  lifecycle({
    componentDidMount() {
      if (isNode || typeof window === 'undefined') return

      if (window.google && window.google.maps) {
        this.props.setIsReady(true)
        return
      }

      const scriptId = 'google-maps-script'
      let script = document.getElementById(scriptId)

      if (!script) {
        script = document.createElement('script')
        script.id = scriptId
        script.src = `https://maps.googleapis.com/maps/api/js?key=${config.GOOGLE_API}&libraries=geometry,drawing,places`

        script.async = true
        script.defer = true

        document.head.appendChild(script)
      }

      this.handleLoad = () => this.props.setIsReady(true)
      script.addEventListener('load', this.handleLoad)
    },

    componentWillUnmount() {
      if (isNode || typeof window === 'undefined') return

      const script = document.getElementById('google-maps-script')
      if (script && this.handleLoad) {
        script.removeEventListener('load', this.handleLoad)
      }
    },
  }),
)(GoogleMapsProviderView)

export const useGoogleMaps = () => useContext(GoogleMapsContext)
